import {createAsyncThunk} from "@reduxjs/toolkit";
import ServerData from "../../common/serverData";


export const fetchManagerBuildings = createAsyncThunk(
    'managers/fetchBuildings',
    async (params, {getState, rejectWithValue}) => {
        try {
            const state = getState();
            const accessToken = state.auth.accessToken;
            let client = new ServerData(null, null, {accessToken: accessToken});
            const response = await client.managers.buildings.getAllManagerBuildings();
            return response;
        } catch (e) {
            return rejectWithValue({});
        }
    }
);
